<template>
  <div class="application">
    <div class="question">{{ $t('promotion_new.applied_on') }}</div>
    <div class="radios">
      <div class="radio">
        <input id="chk_items_appliedOn" type="radio" value="items" v-model="promotion.appliedOn">
        <label for="chk_items_appliedOn">{{ $t('yes') }}</label>

      </div>
      <div class="radio">
        <input id="chk_1_item_appliedOn" type="radio" value="one_item" v-model="promotion.appliedOn">
        <label for="chk_1_item_appliedOn">{{ $t('no') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionApplication",

  props: {
    promotion: Object
  }
}
</script>